import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabase.js';

export default function SignIn() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [err,      setErr]      = useState(null);
  const [unknown,  setUnknown]  = useState(false);
  const [pending,  setPending]  = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null); setUnknown(false); setPending(true);
    const { error } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });
    setPending(false);
    if (!error) return;                     // AuthProvider will pick up the session
    if (/invalid login credentials/i.test(error.message)) {
      // Supabase returns the same error for both "no such user" and "wrong
      // password" (by design, to prevent enumeration). We can't distinguish
      // here, so show the "wrong email or password" copy and keep the "ask
      // to be added" hint below the form.
      setErr('That email and password don\'t match. Try again, or reset your password.');
      setUnknown(true);
    } else {
      setErr(error.message);
    }
  }

  return (
    <div className="signin">
      <img src="/dl-logo.png" alt="Digital Lotus" className="brand-mark" />
      <h1>Digital Lotus Portal</h1>
      <p>Your quarterly plan, blogs to review, and more — in one place.</p>

      <form onSubmit={onSubmit}>
        <input
          type="email"
          placeholder="you@company.com"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={pending}
        />
        <input
          type="password"
          placeholder="Password"
          required
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={pending}
        />
        <button type="submit" disabled={pending || !email || !password}>
          {pending ? 'Signing in…' : 'Sign in'}
        </button>
        {err && <p className="msg err">{err}</p>}
        <p className="hint">
          <Link to="/reset">Forgot your password?</Link>
        </p>
        {unknown && (
          <p className="hint">
            First time here, or don't have a portal account?{' '}
            Ask Digital Lotus to add you.
          </p>
        )}
      </form>
    </div>
  );
}
